import React, { useState } from 'react';
import { BaseModal, ToastMessage } from '@cokitchen/cokitchen-components';
import { RiderAltIcon } from 'cokitchen-icons';
import { NewRiderFormType, RiderFieldType } from './types';
import AddRiderForm from './add-rider-form';
import AddRidersFooter from './add-riders-footer';
import { toast } from 'react-toastify';
import { PartnerType } from 'models/partner.model';
import { apiService } from 'utils/api';
type AddRidersProps = {
  onClose: () => void;
  partner: PartnerType;
};

export type AddRiderFormType = {
  riders: NewRiderFormType[];
};

const AddRidersModal = ({ partner, onClose }: AddRidersProps) => {
  const EMPTY_FORM = {
    first_name: '',
    last_name: '',
    phone_number: '',
    email: '',
    user_gender: '',
    profile_image: '',
    cokitchen_id: '',
    cokitchen_polygon_ids: []
  };
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    riders: [EMPTY_FORM]
  } as AddRiderFormType);
  const addRiders = async () => {
    setLoading(false);
    const data = {
      logistics_company_id: partner.id,
      riders: formData.riders
    };
    try {
      const res = await apiService.post('logistics/super-admin/register-rider', {
        data
      });
      if (res?.data) {
        toast(<ToastMessage type='success' message='Riders added successfully' />);
        onClose();
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  const additionalRiders = () => {
    const riders = [...formData.riders, EMPTY_FORM];
    setFormData({
      ...formData,
      riders: [...riders]
    });
  };

  const handleAddRiders = async (e: any, i: number, field: RiderFieldType) => {
    const riders = [...formData.riders];
    if (field === 'user_gender') {
      riders[i].user_gender = e;
    } else if (field === 'profile_image') {
      riders[i].profile_image = e;
    } else if (field === 'cokitchen_id') {
      riders[i].cokitchen_id = e;
      riders[i].cokitchen_polygon_ids = [];
    } else if (field === 'cokitchen_polygon_ids') {
      riders[i].cokitchen_polygon_ids = e;
    } else {
      riders[i][field] = e.target.value;
    }
    setFormData({ ...formData });
  };

  const confirmDisabled = () => {
    for (let i = 0; i < formData.riders.length; i++) {
      const {
        first_name,
        last_name,
        email,
        phone_number,
        user_gender,
        profile_image,
        cokitchen_id,
        cokitchen_polygon_ids
      } = formData.riders[i];
      if (
        !first_name ||
        !last_name ||
        !email ||
        !phone_number ||
        !user_gender ||
        !profile_image ||
        !cokitchen_id ||
        !cokitchen_polygon_ids.length
      ) {
        return true;
      }
    }
    return false;
  };

  const handleDelete = (i: number) => {
    const filteredManagers = formData.riders.filter((rider, index) => index !== i);
    formData.riders = filteredManagers;
    setFormData({ ...formData });
  };

  return (
    <BaseModal
      position='right'
      isOpen
      onRequestClose={onClose}
      title='Add Riders'
      titleCta={
        <span role='button' className='text-red-5' onClick={additionalRiders}>
          + Additional rider
        </span>
      }
      titleIcon={<RiderAltIcon />}
      footer={
        <AddRidersFooter disabled={confirmDisabled()} loading={loading} onClick={addRiders} />
      }>
      <AddRiderForm
        handleDelete={handleDelete}
        formData={formData}
        handleAddRiders={handleAddRiders}
      />
    </BaseModal>
  );
};

export default AddRidersModal;
